<template>
    <div v-if="progress !== null" class="progress-bar">
        <span
            :class="['progress-bar__indicator', { 'complete': isLearningPathComplete }]"
            :style="{ width: `${progress}%` }"
        >
        </span>
        <span class="progress-bar__text" v-html="getProgressText"></span>
    </div>
</template>

<script>
    export default {
        props: {
            progress: {
                type: Number,
                default: null
            },
            isComplete: {
                type: Boolean,
                default: false
            },
            isSubscribed: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            isLearningPathComplete () {
                return this.progress === 100 || this.isComplete
            },
            getProgressText () {
                if (!this.isSubscribed && this.progress === 0) {
                    return this.$t('LearningPath.not_started')
                }
                if (this.isLearningPathComplete) {
                    return this.$t('LearningPath.completed')
                }
                return `${this.progress}% ${this.$t('LearningPath.completed')}`
            }
        }
    }
</script>

<style lang="scss" scoped>
    .progress-bar {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 30px;
        background: $silver;
        display: flex;
        align-items: center;

        [class*="mobile"] & {
            font-size: 0.8rem;
        }

        [class*="mobile"] & {
            height: 10px;
            right: 0px;
        }

        &__indicator {
            position: absolute;
            height: 30px;
            background: $porsche;
            [class*="mobile"] & {
                height: 10px;
            }

            &.complete {
                background: $de_york;
            }
        }
        &__text {
            margin: 0 auto;
            z-index: 1;
        }
    }
</style>
